var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("system.assign_role"),
            "close-on-click-modal": false,
            visible: _vm.dialogUserVisible,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogUserVisible = $event
            },
            close: _vm.initData,
          },
        },
        [
          _c("div", [
            _c(
              "div",
              { staticClass: "assign-role-form" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      "label-width": "150px",
                      rules: _vm.rules,
                      "label-position": "top",
                    },
                  },
                  [
                    _c("div", { staticClass: "assign-role-container" }, [
                      _c(
                        "div",
                        { staticClass: "assign-role-container-left" },
                        [
                          _c("div", { staticClass: "section-title" }, [
                            _vm._v(_vm._s(_vm.$t("system.authority"))),
                          ]),
                          _c("div", { staticClass: "section-tip" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("tips.following_permission_granted_role")
                              )
                            ),
                          ]),
                          _c("SystemMchMenu", {
                            attrs: {
                              "menu-list": _vm.menuList,
                              "auth-list": _vm.checkAuths,
                              "modal-flag": 3,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "assign-role-container-right" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("system.role_name") + ":",
                                prop: "role_id",
                              },
                            },
                            _vm._l(_vm.roleList, function (role) {
                              return _c(
                                "div",
                                { key: role.id, staticClass: "role-name-item" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "role-name-item-text" },
                                    [_vm._v(" " + _vm._s(role.role_name) + " ")]
                                  ),
                                  _vm.form.role_id === role.id
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "filter-btn-add",
                                          staticStyle: { width: "100px" },
                                          attrs: {
                                            disabled: _vm.masterAccFlag,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleChangeRole(role)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("components.selected")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "el-button",
                                        {
                                          staticStyle: { width: "100px" },
                                          attrs: {
                                            type: "info",
                                            disabled: _vm.masterAccFlag,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleChangeRole(role)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("components.select")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                          _c("div"),
                          _c(
                            "div",
                            {
                              staticClass: "dialog-footer-fixed",
                              attrs: { slot: "footer" },
                              slot: "footer",
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn-diglog-control",
                                  attrs: { type: "primary", plain: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogUserVisible = false
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("components.cancel")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn-diglog-control",
                                  attrs: {
                                    type: "primary",
                                    disabled: _vm.listLoading,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.submitAssignRole("form")
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("components.submit")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }